import React from 'react';

import anyroadLogo from './AR_Logo_SmallScale_Icon_gray.png';

export const Logo = () => (
  <a href="https://www.anyroad.com/">
    <img
      alt="AnyRoad Logo"
      src={anyroadLogo}
      height="30px"
      width="142px"
      style={{ margin: '15px auto 15px 15px' }}
    />
  </a>
);
